G.UI_CoinCounter = function() {

	Phaser.Group.call(this,game);
	this.x = 100;
	this.y = 100;

	this.state = game.state.getCurrentState();
	this.text = new G.TextCounter(0, 0, G.saveState.data.coins, {
		style: "font-white",
		fontSize: "40px"
	}, [1,0.5], 200);
	this.add(this.text);
	this.ico = G.makeImage(0,0,'currency',[0,0.5],this);

	this.alpha = 0;

	G.sb("onScreenResize").add(this.resize,this);
	this.resize();

	G.sb("onBoosterSelect").add(this.init,this);
	G.sb("closeOverlay").add(this.hide,this);

	G.sb("onCoinsChange").add(this.text.setAmount,this.text);

};

G.UI_CoinCounter.prototype = Object.create(Phaser.Group.prototype);


G.UI_CoinCounter.prototype.resize = function() {
	/**
	 * Horizontal feedback for booster labels seemed like it was a half done job sort of thing
	 * Plus it is not certain that there is even enough horizontal space for the text to be in at a certain resolution
	 * Maybe in the future we can use the horizontal space but for now, what works well should be used.
	*/
	// if (G.horizontal) {
		// this.x = 0;
		// this.y = G.l(700);
	// } else {
		this.x = G.l(330);
		this.x += Math.floor(this.text.width*0.5);
	// }

	this.y = this.state.board.y - G.l(50);

};


G.UI_CoinCounter.prototype.init = function(boosterData) {
	
	const boosterNr = boosterData.boosterNr;
	if (G.saveState.getBoosterAmount(boosterNr) <= 0) {

		this.alpha = 0;
		G.stopTweens(this);
		game.add.tween(this).to({alpha:1},500,Phaser.Easing.Sinusoidal.Out,true);
		this.resize();

	}

};

G.UI_CoinCounter.prototype.hide = function() {
	
	G.stopTweens(this);
	game.add.tween(this).to({alpha:0},500,Phaser.Easing.Sinusoidal.Out,true);

};
